import React from "react";
import { FGrid } from "ferrum-design-system";
import circleIcon from "../../../../assets/ms-new-images/icons/circleIcon.png";
import animateLoadingIcon from "../../../../assets/gif/MultiSwap-anima-loading-infinite.gif";
import "react-step-progress-bar/styles.css";
import { ProgressBar, Step } from "react-step-progress-bar";
import tickIcon from "../../../../assets/img/ic-tick-circle.png";
import fiberRouterIcon from "../../../../assets/ms-new-images/fiberRouterIcon.png";
import { useSelector } from "react-redux";

export const SwapProgressBar = ({
  networkProgressBarDisable,
  swapProgressBar,
  progressBar,
  amount,
}: any) => {
  const { fromInfo, toInfo } = useSelector((state: any) => state.swap);

  return (
    <>
      {networkProgressBarDisable && (
        <>
          <div>
            <div className="progress-bar-container">
              <FGrid className="" spacing={1}>
                <ProgressBar
                  width={1120}
                  height={2}
                  percent={swapProgressBar}
                  filledBackground="#D9B373"
                >
                  <Step transition="scale">
                    {({ accomplished }) => (
                      <>
                        <img
                          width="15"
                          height={15}
                          src={
                            accomplished
                              ? swapProgressBar > 0
                                ? tickIcon
                                : animateLoadingIcon
                              : circleIcon
                          }
                        />
                      </>
                    )}
                  </Step>

                  <Step transitionDuration={1000} transition="scale">
                    {({ accomplished }) => (
                      <img
                        width="15"
                        height={15}
                        src={
                          accomplished
                            ? swapProgressBar > 12
                              ? tickIcon
                              : animateLoadingIcon
                            : circleIcon
                        }
                      />
                    )}
                  </Step>
                  <Step transition="scale">
                    {({ accomplished }) => (
                      <img
                        width="15"
                        height={15}
                        src={
                          accomplished
                            ? swapProgressBar > 24
                              ? tickIcon
                              : animateLoadingIcon
                            : circleIcon
                        }
                      />
                    )}
                  </Step>

                  <Step transition="scale">
                    {({ accomplished }) => (
                      <img
                        width="15"
                        height={15}
                        src={
                          accomplished
                            ? swapProgressBar > 36
                              ? tickIcon
                              : animateLoadingIcon
                            : circleIcon
                        }
                      />
                    )}
                  </Step>
                  <Step transition="scale">
                    {({ accomplished }) => (
                      <img
                        width="15"
                        height={15}
                        src={
                          accomplished
                            ? swapProgressBar > 48
                              ? tickIcon
                              : animateLoadingIcon
                            : circleIcon
                        }
                      />
                    )}
                  </Step>
                  <Step transition="scale">
                    {({ accomplished }) => (
                      <img
                        width="15"
                        height={15}
                        src={
                          accomplished
                            ? swapProgressBar > 60
                              ? tickIcon
                              : animateLoadingIcon
                            : circleIcon
                        }
                      />
                    )}
                  </Step>
                  <Step transition="scale">
                    {({ accomplished }) => (
                      <img
                        width="15"
                        height={15}
                        src={
                          accomplished
                            ? swapProgressBar > 72
                              ? tickIcon
                              : animateLoadingIcon
                            : circleIcon
                        }
                      />
                    )}
                  </Step>
                  <Step transition="scale">
                    {({ accomplished }) => (
                      <img
                        width="15"
                        height={15}
                        src={
                          accomplished
                            ? swapProgressBar > 84
                              ? tickIcon
                              : animateLoadingIcon
                            : circleIcon
                        }
                      />
                    )}
                  </Step>
                  <Step transition="scale">
                    {({ accomplished }) => (
                      <img
                        width="15"
                        height={15}
                        src={
                          accomplished
                            ? swapProgressBar > 96
                              ? tickIcon
                              : animateLoadingIcon
                            : circleIcon
                        }
                      />
                    )}
                  </Step>
                </ProgressBar>
              </FGrid>
            </div>
            <div className="custom-swap-step-bar">
              <p
                className="custom-step-bar-text"
                style={{
                  color: swapProgressBar >= 0 ? "#FFFFFF" : "gray",
                }}
              >
                FIBER <br />
                Router <img src={fromInfo?.network.logo} />
              </p>
              <p
                className="custom-step-bar-text"
                style={{
                  color: swapProgressBar > 12 ? "#FFFFFF" : "gray",
                }}
              >
                FUND <br />
                MANAGER <img src={fromInfo?.network.logo} />
              </p>
              <p
                className="custom-step-bar-text"
                style={{
                  color: swapProgressBar > 24 ? "#FFFFFF" : "gray",
                }}
              >
                Node <br />
                Verification
              </p>
              <p
                className="custom-step-bar-text"
                style={{
                  color: swapProgressBar > 36 ? "#FFFFFF" : "gray",
                }}
              >
                FIBER <br />
                Router <img src={toInfo?.network.logo} />
              </p>
              <p
                className="custom-step-bar-text"
                style={{
                  color: swapProgressBar > 48 ? "#FFFFFF" : "gray",
                }}
              >
                FUND <br />
                Manager <img src={toInfo?.network.logo} />
              </p>
              <p
                className="custom-step-bar-text"
                style={{
                  color: swapProgressBar > 60 ? "#FFFFFF" : "gray",
                }}
              >
                DEX <br />
                Router <img src={fiberRouterIcon} />
              </p>
              <p
                className="custom-step-bar-text"
                style={{
                  color: swapProgressBar > 72 ? "#FFFFFF" : "gray",
                }}
              >
                DEX <br />
                Liquidity Pool
              </p>
              <p
                className="custom-step-bar-text"
                style={{
                  color: swapProgressBar > 84 ? "#FFFFFF" : "gray",
                }}
              >
                FIBER <br />
                Router <img src={toInfo?.network.logo} />
              </p>
              <p
                className="custom-step-bar-text"
                style={{
                  color: swapProgressBar > 96 ? "#FFFFFF" : "gray",
                }}
              >
                Destination <br />
                Wallet
              </p>
            </div>
          </div>
        </>
      )}
    </>
  );
};
